module.exports = __webpack_public_path__ + "static/media/associateAnd2.08961878.JPG";